import { PolicyTier, ProductType } from "redmond";

export const getIsDefaultPolicySelected = (policies?: PolicyTier) =>
  !policies ||
  (isDefaultHotelPolicySelected(policies) &&
    isDefaultCarPolicySelected(policies) &&
    isDefaultFlightPolicySelected(policies));

export const getIsDefaultPolicyForProduct = (
  policies?: PolicyTier,
  productType?: ProductType
) => {
  if (!policies) return true;
  switch (productType) {
    case "hotel":
    case "home":
      return isDefaultHotelPolicySelected(policies);
    case "flight":
      return isDefaultFlightPolicySelected(policies);
    case "car":
      return isDefaultCarPolicySelected(policies);
    default:
      return getIsDefaultPolicySelected(policies);
  }
};

const isDefaultHotelPolicySelected = (policyTier?: PolicyTier): boolean => {
  return (
    !!policyTier &&
    policyTier.hotels.policies.every((policy) => {
      const isAllStarRatingsAllowed = policy.allowedStarRatings.length === 5;
      const noMaxPricePolicy = policy.maxPricePerNight === undefined;
      return isAllStarRatingsAllowed && noMaxPricePolicy;
    })
  );
};

const isDefaultCarPolicySelected = (policyTier?: PolicyTier): boolean => {
  return (
    !!policyTier &&
    policyTier.cars.policies.every((policy) => {
      const noMaxPricePolicy = policy.maxPricePerDay === undefined;
      return noMaxPricePolicy;
    })
  );
};

const isDefaultFlightPolicySelected = (policyTier?: PolicyTier): boolean => {
  return (
    !!policyTier &&
    policyTier.flights.enableLongFlights &&
    policyTier.flights.policies.every((policy) => {
      const noMaxPrice =
        policy.maxPriceForOneWay == undefined &&
        policy.maxPriceForRoundTrip == undefined;
      const allFareClassesIncluded = policy.allowedFareClasses.length == 5;
      return noMaxPrice && allFareClassesIncluded;
    })
  );
};
